import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionsColumnComponent } from './actions-column.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  declarations: [ActionsColumnComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule
  ],
  exports: [ActionsColumnComponent]
})
export class ActionsColumnModule { }
